exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-pagination__navigation:focus,\n.v-pagination__item:focus {\n  outline: 0px;\n}\n.app-pagination .v-text-field {\n  max-width: 51px;\n}\n.app-pagination #pagination-input {\n  text-align: center;\n}\n", ""]);

// exports
